import { render, staticRenderFns } from "./CompanyProfile7.vue?vue&type=template&id=381cc120&scoped=true&"
import script from "./CompanyProfile7.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile7.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile7.vue?vue&type=style&index=0&id=381cc120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381cc120",
  null
  
)

export default component.exports